import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function OTPError(props) {
    return (React.createElement(Svg, { width: 16, height: 16, viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', ...props },
        React.createElement(Path, { d: 'M8 1.333A6.67 6.67 0 001.333 8 6.669 6.669 0 008 14.667 6.669 6.669 0 0014.667 8 6.669 6.669 0 008 1.333z', fill: '#FEECEB' }),
        React.createElement(Path, { d: 'M7.926 10.667a.593.593 0 100-1.186.593.593 0 000 1.186zM7.926 5.333a.594.594 0 00-.593.593v2.37c0 .326.267.593.593.593a.594.594 0 00.593-.593v-2.37a.594.594 0 00-.593-.593z', fill: '#F04438' })));
}
export default OTPError;
